import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react'; // Lepsza ikona z biblioteki

// Dodanie importu czcionki Inter
const fontLink = document.createElement('link');
fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;600;900&display=swap';
fontLink.rel = 'stylesheet';
document.head.appendChild(fontLink);

function ThankYouPage() {
  return (
    <div className="bg-black text-white min-h-screen flex flex-col items-center justify-center text-center p-6 relative overflow-hidden">
      {/* Dekoracyjne tło */}
      <div className="absolute inset-0 opacity-10 z-0">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-violet-600/20 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-violet-700/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }}></div>
      </div>
      
      <div className="relative z-10 flex flex-col items-center">
        <CheckCircle className="w-24 h-24 text-violet-600 mb-6" strokeWidth={1.5} />
        <h1 
          className="text-3xl sm:text-5xl md:text-6xl font-black mb-4 uppercase leading-tight"
          style={{ fontFamily: 'Inter, sans-serif', fontWeight: 900 }}
        >
          Dziękujemy!
        </h1>
        <p className="text-xl text-gray-300 mb-8 max-w-lg mx-auto">
          Twoje zapytanie zostało pomyślnie wysłane. Skontaktujemy się z Tobą wkrótce.
        </p>
        <Link 
          to="/" 
          className="bg-gradient-to-r from-violet-600 to-violet-700 hover:from-violet-700 hover:to-violet-800 text-white font-bold py-3 px-8 rounded-full text-lg transition-all duration-300 hover:scale-105"
        >
          Powrót na Stronę Główną
        </Link>
      </div>

      <style>{`
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: .5; }
          }
          .animate-pulse {
            animation: pulse 4s cubic-bezier(0.4, 0, 0.6, 1) infinite;
          }
      `}</style>
    </div>
  );
}

export default ThankYouPage;